import { render, staticRenderFns } from "./contract-attachment_v2.vue?vue&type=template&id=4b7550da&"
import script from "./contract-attachment_v2.vue?vue&type=script&lang=js&"
export * from "./contract-attachment_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports